const cardsMeta = [
  {
    type: 'industryExpert',
    name: 'Industry Experts',
    img: '/images/categoryPage/Experts.svg',
  },
  {
    type: 'hiringPartners',
    name: 'Hiring Partners',
    img: '/images/categoryPage/Hiring.svg',
  },
  {
    type: 'highestSalary',
    name: 'Highest Package',
    img: '/images/categoryPage/Package.svg',
  },
  {
    type: 'learnersPlaced',
    name: 'Learners Placed',
    img: '/images/categoryPage/Learners.svg',
  },
];

export default cardsMeta;
